import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://hjftoajbsdcimbvpoxnr.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqZnRvYWpic2RjaW1idnBveG5yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI5NjgwNTAsImV4cCI6MjA5ODU0NDA1MH0.5c5CFXjJW9tJUf_7dG3sOGyBCwCXmmrKkLGUrJlkwUA"
);